<div class="error-container">
  <aur-notice
    severity="error"
    title="{{ 'ARC_PAYMENT_LINKS_LINK_EXPIRED_TITLE' | translate }}"
  >
    {{ 'ARC_PAYMENT_LINKS_LINK_EXPIRED' | translate }}
  </aur-notice>
</div>
